// src/components/AlertMessage.js

import React, { useContext } from "react";
import { AlertContext } from "../contexts/AlertContext";

const AlertMessage = () => {
  const { alert, hideAlert } = useContext(AlertContext);

  if (!alert) return null;

  const { type, message } = alert;

  return (
    <div
      className="position-fixed top-0 start-50 translate-middle-x p-3"
      style={{ zIndex: 9999, maxWidth: "90%", width: "auto" }}
    >
      <div
        className={`alert alert-${type} alert-dismissible fade show d-flex align-items-center`}
        role="alert"
      >
        <span className="flex-grow-1">{message}</span>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={hideAlert}
        ></button>
      </div>
    </div>
  );
};

export default AlertMessage;
